import React, { memo } from 'react';
import pt from 'prop-types';
import Status from 'components/status';
import ReviewStatus from './review-status';

function AppStatus({ app, blank = false }) {
  const published = app.$version
    ? app.published_props?.version === app.version
    : app.published;

  return (
    <div className="app-status">
      <Status type={published ? 'positive' : 'muted'} blank={blank}>
        {published ? 'Published' : app.client_id ? 'Private' : 'Unpublished'}
      </Status>
      {!app.$version && <ReviewStatus app={app} />}
    </div>
  );
}

AppStatus.propTypes = {
  app: pt.object,
  blank: pt.bool,
};

export default memo(AppStatus);
